module.exports = __webpack_public_path__ + "static/img/image_solutions_optics_02.e063e63.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/solution/image_solutions_optics_02.png
// module id = AOoN
// module chunks = 10